<div
  class="max-w-screen-lg p-2 flex flex-col items-center justify-center bg-white rounded-md"
  style="width: 500px"
>
  <div class="text-xl font-bold">Invite Users</div>

  <div
    class="mt-2"
    [ngClass]="{ invisible: !invalidInput, visible: invalidInput }"
  >
    <span class="block text-red tex-sm">Not a valid email.</span>
  </div>

  <div class="w-72">
    <confect-select
      (click)="invalidInput = false"
      [options]="modalUsers"
      [multiple]="true"
      [searchable]="true"
      [searchFn]="customSearchFn"
      [placeholder]="modalUsers.length > 0 ? 'Enter user email' : ''"
      [(ngModel)]="users"
      [addTag]="addTag"
      bindLabel="name"
      bindSubLabel="email"
      bindValue="email"
      addTagText="Add user: "
      [clearable]="true"
      notFoundText="Enter emails to invite"
    />
  </div>
  <div class="w-full flex items-center justify-center space-x-5 mt-8">
    <confect-button type="secondary" (click)="closeModal()">
      Cancel
    </confect-button>
    <confect-button type="primary" (click)="inviteUsers()">
      Invite
    </confect-button>
  </div>
</div>
